const COUNTRIES_JSON_URL = `${process.env.PUBLIC_URL || ''}/data/countries.json`;

let cachedCountries = null;
let loadPromise = null;

export async function loadCountriesData() {
  if (cachedCountries) {
    return cachedCountries;
  }

  if (!loadPromise) {
    loadPromise = fetch(COUNTRIES_JSON_URL)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`No se pudo cargar countries.json (${response.status})`);
        }
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) {
          throw new Error('countries.json debe ser un array');
        }
        cachedCountries = data;
        return data;
      })
      .catch((err) => {
        loadPromise = null;
        throw err;
      });
  }

  return loadPromise;
}

export function buildCountrySelectOptions(data) {
  return data.map((country, index) => ({
    label: country.name?.common || country.cca3 || '',
    value: country.cca3,
    flagUrl: country.flags?.svg || country.flags?.png || '',
    index,
  }));
}

export function buildCountryPhoneOptions(data) {
  const validCountries = data.filter((country) => country.idd && country.idd.root);

  const formatted = validCountries.map((country, index) => {
    const fullDialCode =
      country.idd.root + (country.idd.suffixes ? country.idd.suffixes[0] : '');

    return {
      label: `${country.name?.common || country.cca3} (${fullDialCode})`,
      value: fullDialCode,
      flagUrl: country.flags?.svg || country.flags?.png || '',
      index,
    };
  });

  formatted.sort((a, b) => a.label.localeCompare(b.label));
  return formatted;
}

export function buildCountryNameOptions(data) {
  return data
    .map((country, index) => ({
      label: country.name?.common ?? '',
      value: country.name?.common ?? '',
      flagUrl: country.flags?.svg || country.flags?.png || '',
      index,
    }))
    .filter((country) => country.label)
    .sort((a, b) => a.label.localeCompare(b.label));
}

function normalizeCountryKey(value) {
  return String(value || '').trim().toLowerCase();
}

export function buildCountryIndex(countries) {
  const byCca3 = {};
  const byName = {};

  countries.forEach((country) => {
    const latlng = country.latlng;
    if (!Array.isArray(latlng) || latlng.length < 2) return;

    const cca3 = String(country.cca3 || '').trim().toUpperCase();
    if (!cca3) return;

    const entry = {
      cca3,
      lat: latlng[0],
      lng: latlng[1],
      name: country.name?.common || cca3,
    };

    byCca3[cca3] = entry;
    const cca2 = String(country.cca2 || '').trim().toUpperCase();
    if (cca2) byCca3[cca2] = entry;

    const names = [
      country.name?.common,
      country.name?.official,
      ...(country.name?.nativeName
        ? Object.values(country.name.nativeName).map((n) => n?.common)
        : []),
      ...(country.name?.native
        ? Object.values(country.name.native).map((n) => n?.common)
        : []),
    ].filter(Boolean);

    names.forEach((name) => {
      byName[normalizeCountryKey(name)] = cca3;
    });
  });

  return { byCca3, byName };
}
